import { createContext, useReducer, useContext, useEffect } from 'react';
import initialState from './initialState';
import reducer from './reducer';
import { guestKey } from '../services/constants';
import { changeKey } from './asyncActions';
import { useLocalStorage } from './helpers';

import * as actions from './actions';
export { actions };

const StoreContext = createContext();

export const StoreProvider = ({ modelVersion, ...props }) => {
    const [store, dispatch] = useReducer(reducer, initialState(modelVersion));
    const { readValue } = useLocalStorage();

    /* Initialize for model version */
    useEffect(() => {
        const storedValue = readValue('key');
        if (!store.key && storedValue) {
            dispatch(actions.setStoreKeyInBrowser(true));
        }
        const key = store.key ?? readValue('key') ?? guestKey;

        const promise = changeKey({ modelVersion }, dispatch, key);

        return () => {
            promise?.abort?.();
        };
    }, [modelVersion, store.key]);

    // useEffect(() => {
    //     // const queryParams = new URLSearchParams(window.location.search);
    //     // const key = queryParams.get('key');
    //     const key = sessionStorage.getItem('key');
    //     if (key) {
    //         // handleLogin(key);
    //         dispatch(setKey(key));
    //     }
    // }, []);

    return <StoreContext.Provider value={{ store, dispatch }} {...props} />;
};

/**
 * @typedef {import('./initialState').TStore} TStore
 * @typedef {Object} TStoreContext
 * @property {TStore} store
 * @property {function} dispatch
 *
 * @returns {TStoreContext}
 */
const useStore = () => useContext(StoreContext);

export default useStore;
